<template>
  <div class="bg">
    <div class="button">
      <i @click="showSearch = true" class="iconfont icon-chaxun"></i>
      <el-button size="mini" type="primary" @click="batchIssue">批量下发</el-button>
      <van-popup
        v-model="showSearch"
        round
        position="bottom"
        :style="{ height: 'auto' }"
        closeable
      >
        <van-field
          v-model="sn"
          clearable
          label="设备编号："
          placeholder="请输入要查询的设备编号"
        />
        <van-field
          v-model="name"
          clearable
          label="工人姓名："
          placeholder="请输入要查询的工人姓名"
        />
        <div class="searchBtn">
          <span
            style="font-size: 14px; color: #576b95; padding-right: 16px"
            @click="itemList"
            >查询记录</span
          >
        </div>
        <van-picker
          show-toolbar
          toolbar-position="bottom"
          cancel-button-text=" "
          :columns="typeOptions"
          confirm-button-text="查询记录"
          item-height="35"
          @confirm="onConfirmType"
        />
        <van-picker
          show-toolbar
          toolbar-position="bottom"
          cancel-button-text=" "
          :columns="statusOptions"
          item-height="35"
          confirm-button-text="查询记录"
          @confirm="onConfirmStatus"
        />
      </van-popup>
    </div>
    <div v-show="showPagination !== 0">
      <div class="selectAll">
        <el-checkbox
          v-model="checkedAll"
          :indeterminate="isIndeterminate"
          @change="checkAll"
        >
          全选
        </el-checkbox>
      </div>
      <el-checkbox-group v-model="checkedOne" @change="checkOne">
        <div class="content">
          <el-card v-for="(item, index) in itemInfo" :key="index">
            <el-checkbox :label="item">
              <el-row>
                <el-col :span="8">
                  <div class="img">
                    <van-image height="150" :src="item.head" fit="cover" />
                  </div>
                </el-col>
                <el-col :span="16">
                  <p>
                    <span>所属项目：{{ project }}</span>
                  </p>
                  <p>
                    <span>设备编号：{{ item.sn }}</span>
                  </p>
                  <p>
                    <span>工人姓名：{{ item.name }}</span>
                  </p>
                  <p>
                    <el-col :span="24"> 命令类型：{{ item.type }} </el-col>
                  </p>
                  <p>
                    <el-col :span="24"> 命令状态：{{ item.status }} </el-col>
                  </p>
                  <p>
                    <el-col :span="24"> 下发结果：{{ item.result }} </el-col>
                  </p>
                </el-col>
              </el-row>
              <el-row>
                <!-- <el-col :span="24"></el-col> -->
                <el-col :span="24"> 证件号码：{{ item.idCardNumber }} </el-col>
                <el-col :span="24"> 下发时间：{{ item.createTime }} </el-col>
                <el-col :span="24"> 更新时间：{{ item.updateTime }} </el-col>
                <el-col
                  v-if="item.status !== '下发成功'"
                  :span="24"
                  style="text-align: right"
                >
                  <el-button type="primary" size="mini" @click="issue(item.id)">
                    重新下发
                  </el-button>
                </el-col>
              </el-row>
            </el-checkbox>
          </el-card>
          <el-card v-show="showPagination == 0" body-style="text-align:center">
            <span>暂无数据</span>
          </el-card>
        </div>
      </el-checkbox-group>
      <el-pagination
        :current-page.sync="page.currentPage"
        :page-sizes="page.pageSizes"
        :page-size="page.pageSize"
        :total="page.totalCount"
        layout="sizes ,pager, next "
        :on-load="itemList"
        @size-change="sizeChange"
        @current-change="currentChange"
      />
    </div>
    <el-card v-show="showPagination == 0" body-style="text-align:center">
      <span>暂无数据</span>
    </el-card>
    <div style="margin-top: 10px; text-align: right">
      <el-button v-show="showPagination == 0" size="mini" type="primary" @click="goBack">
        返回
      </el-button>
    </div>
  </div>
</template>
<script>
import { postProjectId } from "@/api/app/project";
import { postListPage, postReissue } from "@/api/app/issueOrder";
let ids = [];
export default {
  data() {
    return {
      page: {
        pageSize: 10,
        currentPage: 1,
        totalCount: 0,
        pageSizes: [10, 20, 30, 40, 50, 100],
      },
      itemInfo: {},
      query: {},
      // 查询弹窗显隐状态
      showSearch: false,
      // 全选，单选
      checkedAll: false,
      isIndeterminate: false,
      checkedOne: [],
      showPagination: Number,
      sn: "",
      name: "",
      typeOptions: [],
      statusOptions: [],
    };
  },
  computed: {
    // 监听头部选择项目后vuex中projectId值的变化
    projectIdVuex() {
      return this.$store.state.app.projectId;
    },
  },
  watch: {
    // 监听头部选择项目后vuex中projectId值的变化
    projectIdVuex(e) {
      if (e !== this.projectId) {
        // 获取项目信息
        this.itemList();
      }
    },
  },
  created() {
    this.itemList();
  },
  methods: {
    // 获取列表信息
    itemList(page, params = {}) {
      // 根据vuex的寸的projectId获取所属项目名称
      postProjectId(this.$store.state.app.projectId).then((res) => {
        this.project = res.data.name;
      });
      if (this.name !== "") {
        this.query.name = this.name;
      }
      if (this.sn !== "") {
        this.query.sn = this.sn;
      }
      this.query.projectId = this.$store.state.app.projectId;
      postListPage(
        this.page.currentPage,
        this.page.pageSize,
        Object.assign(params, this.query)
      ).then((res) => {
        this.page = res.data;
        this.showPagination = res.data.result.length;
        this.showSearch = false;
        let type = [
          {
            text: "采集下发",
            value: 1,
          },
          {
            text: "手动下发",
            value: 2,
          },
          {
            text: "退场下发",
            value: 3,
          },
          {
            text: "进场下发",
            value: 4,
          },
        ];
        let status = [
          {
            text: "等待下发",
            value: 0,
          },
          {
            text: "已经下载",
            value: 1,
          },
          {
            text: "下发成功",
            value: 2,
          },
          {
            text: "下发失败",
            value: 3,
          },
        ];
        this.typeOptions = type;
        this.statusOptions = status;
        // 命令类型
        res.data.result.forEach((res) => {
          type.find((item) => {
            if (res.type == item.value) {
              res.type = item.text;
            }
          });
        });
        // 命令状态
        res.data.result.forEach((res) => {
          status.find((item) => {
            if (res.status == item.value) {
              res.status = item.text;
            }
          });
        });
        this.itemInfo = res.data.result;
      });
    },
    onConfirmType(value) {
      this.query.type = value.value;
      this.itemList();
      this.showSearch = false;
    },
    onConfirmStatus(value) {
      this.query.status = value.value;
      this.itemList();
      this.showSearch = false;
    },
    goBack() {
      if (this.name !== "" || this.sn !== "") {
        location.reload();
      } else {
        this.$router.back();
      }
    },
    // 图片预览
    showImage(index) {
      ImagePreview({
        images: [index],
      });
    },
    // 分页
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.itemList(this.page);
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.itemList(this.page);
    },
    // el-card全选
    checkAll(val) {
      this.checkedOne = val ? this.itemInfo : [];
      this.isIndeterminate = false;
      if (val == true) {
        ids = this.itemInfo.map((item) => {
          return item.id;
        });
      } else {
        ids = [];
      }
    },
    // el-card选中单个
    checkOne(value) {
      let checkedCount = value.length;
      this.checkedAll = checkedCount === this.itemInfo.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.itemInfo.length;
      ids = value.map((item) => {
        return item.id;
      });
    },
    // 批量下发
    batchIssue() {
      if (ids.length == 0) {
        this.$notify({
          type: "warning",
          message: "至少选择一条数据才能继续操作！",
        });
      } else {
        this.$dialog
          .confirm({
            message: "确定批量下发吗？",
          })
          .then(() => {
            postReissue(ids).then((res) => {
              this.$notify({ type: "success", message: "下发成功！" });
              this.itemList();
            });
          });
      }
    },
    // 单个下发
    issue(ids) {
      this.$dialog
        .confirm({
          message: "确定重新下发吗？",
        })
        .then(() => {
          postReissue([ids]).then((res) => {
            this.$notify({ type: "success", message: "下发成功！" });
            this.itemList();
          });
        });
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  margin-bottom: 50px;
  padding: 10px;
  min-height: 100vh;
  background-color: #f0f0f0;
}
// 操作按钮
.button {
  width: 100%;
  display: flex;
  text-align: right;
  justify-content: flex-end;
  margin-bottom: 10px;
  align-items: center;
  .search {
    width: inherit;
  }
  i {
    font-size: 24px;
    color: #606266;
    margin-right: 5px;
  }
  .van-field:nth-child(1) {
    margin-top: 45px;
  }
  .van-popup {
    padding-bottom: 30px;
  }
  /deep/ .van-picker__columns {
    height: 230px;
  }
  // /deep/ .el-button {
  //   margin-right: 10px;
  // }
  .searchBtn {
    margin-top: 20px;
  }
}

// 全选
.selectAll {
  margin-bottom: 10px;
}
// 多选框
/deep/ .el-checkbox__inner {
  width: 19px;
  height: 19px;
  border-radius: 50%;
}
/deep/ .el-checkbox__inner::after {
  top: 3px;
  left: 7px;
}
.content {
  font-size: 14px;
  /deep/ .el-checkbox {
    width: 100%;
  }

  /deep/ .el-checkbox__label {
    width: 100%;
  }
  .el-card {
    margin-bottom: 10px;
  }
  .el-col {
    margin-bottom: 5px;
  }

  // 图片
  .img {
    img {
      width: 130px;
      height: 130px;
      border-radius: 4px;
    }
  }
  P {
    margin: 0 0 10px 5px;
  }
  // 多选框
  /deep/ .el-checkbox__input {
    position: absolute !important;
    left: -10px;
  }
}
// 分页
/deep/ .el-pagination {
  padding: 0;
  overflow: hidden;
}
/deep/ .el-pagination .el-select .el-input {
  margin: 0;
}
</style>
